import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
    name: 'dateformatter'
})
// La pipe standard di angular per la formattazione delle date non � compatibile con IE11
// E' necessario dunque crearne una custom
export class DateFormatterPipe implements PipeTransform {
    transform(value: any, format: string = ""): string {
        if (!value || value === "") {
          return "";
        }
        return moment(value).format(format);
    }
}
